'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { ClothingItem } from '@/types/closet';
import { Overlay } from './Overlay';
export function GarmentOverlay(t0) {
  const $ = _c(40);
  const {
    item,
    onClose
  } = t0;
  const href = item.url && /^https?:\/\//.test(item.url) ? item.url : undefined;
  let t1;
  if ($[0] !== item.imageUrl || $[1] !== item.name) {
    t1 = <Image unoptimized={true} src={item.imageUrl} alt={item.name} width={500} height={600} className="object-contain" />;
    $[0] = item.imageUrl;
    $[1] = item.name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== item.name) {
    t2 = <h2>{item.name}</h2>;
    $[3] = item.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <dt>Brand</dt>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = item.brand || "Not recorded";
  let t5;
  if ($[6] !== t4) {
    t5 = <div>{t3}<dd>{t4}</dd></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <dt>Category</dt>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== item.category) {
    t7 = <div>{t6}<dd>{item.category}</dd></div>;
    $[9] = item.category;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <dt>Colour</dt>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== item.color) {
    t9 = Array.isArray(item.color) ? item.color.join(", ") || "Not recorded" : String(item.color || "Not recorded");
    $[12] = item.color;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <div>{t8}<dd>{t9}</dd></div>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <dt>Size</dt>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = item.size || "Not recorded";
  let t13;
  if ($[17] !== t12) {
    t13 = <div>{t11}<dd>{t12}</dd></div>;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== item.price) {
    t14 = item.price !== undefined && <div><dt>Price</dt><dd>${item.price.toLocaleString("en-US")}</dd></div>;
    $[19] = item.price;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t10 || $[22] !== t13 || $[23] !== t14 || $[24] !== t5 || $[25] !== t7) {
    t15 = <dl className="lookbook-metadata">{t5}{t7}{t10}{t13}{t14}</dl>;
    $[21] = t10;
    $[22] = t13;
    $[23] = t14;
    $[24] = t5;
    $[25] = t7;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== href) {
    t16 = href && <a href={href} target="_blank" rel="noopener noreferrer" className="lookbook-button">Original listing ↗</a>;
    $[27] = href;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t15 || $[30] !== t16 || $[31] !== t2) {
    t17 = <div>{t2}{t15}{t16}</div>;
    $[29] = t15;
    $[30] = t16;
    $[31] = t2;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t1 || $[34] !== t17) {
    t18 = <div className="lookbook-garment-overlay">{t1}{t17}</div>;
    $[33] = t1;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== item.name || $[37] !== onClose || $[38] !== t18) {
    t19 = <Overlay label={item.name} onClose={onClose}>{t18}</Overlay>;
    $[36] = item.name;
    $[37] = onClose;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
}